/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Due_Date_Clear_OptionInputs */

const en_explorer_info_due_date_clear_option = /** @type {(inputs: Explorer_Info_Due_Date_Clear_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear due date`)
};

const fr_explorer_info_due_date_clear_option = /** @type {(inputs: Explorer_Info_Due_Date_Clear_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear due date`)
};

const de_explorer_info_due_date_clear_option = /** @type {(inputs: Explorer_Info_Due_Date_Clear_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear due date`)
};

const it_explorer_info_due_date_clear_option = /** @type {(inputs: Explorer_Info_Due_Date_Clear_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear due date`)
};

const ru_explorer_info_due_date_clear_option = /** @type {(inputs: Explorer_Info_Due_Date_Clear_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear due date`)
};

const es_explorer_info_due_date_clear_option = /** @type {(inputs: Explorer_Info_Due_Date_Clear_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear due date`)
};

const zh_cn2_explorer_info_due_date_clear_option = /** @type {(inputs: Explorer_Info_Due_Date_Clear_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear due date`)
};

const ja_explorer_info_due_date_clear_option = /** @type {(inputs: Explorer_Info_Due_Date_Clear_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear due date`)
};

const hi_explorer_info_due_date_clear_option = /** @type {(inputs: Explorer_Info_Due_Date_Clear_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear due date`)
};

const pt_pt2_explorer_info_due_date_clear_option = /** @type {(inputs: Explorer_Info_Due_Date_Clear_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear due date`)
};

/**
* | output |
* | --- |
* | "Clear due date" |
*
* @param {Explorer_Info_Due_Date_Clear_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_due_date_clear_option = /** @type {((inputs?: Explorer_Info_Due_Date_Clear_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Due_Date_Clear_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_due_date_clear_option(inputs)
	if (locale === "de") return de_explorer_info_due_date_clear_option(inputs)
	if (locale === "it") return it_explorer_info_due_date_clear_option(inputs)
	if (locale === "ru") return ru_explorer_info_due_date_clear_option(inputs)
	if (locale === "es") return es_explorer_info_due_date_clear_option(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_due_date_clear_option(inputs)
	if (locale === "ja") return ja_explorer_info_due_date_clear_option(inputs)
	if (locale === "hi") return hi_explorer_info_due_date_clear_option(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_due_date_clear_option(inputs)
	return en_explorer_info_due_date_clear_option(inputs)
});